import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Icon from '../AppIcon';
import Button from '../ui/Button';
import { useRequestBuilder } from '../context/RequestBuilderContext';
import { formatRequestAmount } from './requestBuilderUtils';

const RequestTray = () => {
  const { itemCount, subtotal, hasRangePricing, clearAll, openDrawer } = useRequestBuilder();

  return (
    <AnimatePresence>
      {itemCount > 0 && (
        <motion.div
          initial={{ y: '100%', opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: '100%', opacity: 0 }}
          transition={{ type: 'spring', stiffness: 330, damping: 32 }}
          className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-card/95 shadow-2xl backdrop-blur-md"
        >
          <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-3 md:px-8">
            <button
              type="button"
              onClick={openDrawer}
              className="flex min-w-0 flex-1 items-center gap-3 text-left"
              aria-label="Open request builder"
            >
              <span className="relative flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                <Icon name="ClipboardList" size={20} />
                <span className="absolute -right-1 -top-1 min-w-5 rounded-full bg-primary px-1 text-center text-[11px] font-bold leading-5 text-primary-foreground">
                  {itemCount}
                </span>
              </span>
              <span className="min-w-0">
                <span className="block truncate text-sm font-semibold text-foreground">
                  Custom request
                </span>
                <span className="block text-xs text-muted-foreground">
                  {hasRangePricing ? `Starting from ${formatRequestAmount(subtotal)}` : `Estimated ${formatRequestAmount(subtotal)}`}
                </span>
              </span>
            </button>

            <Button type="button" variant="ghost" size="sm" onClick={clearAll}>
              Clear
            </Button>
            <Button type="button" size="sm" onClick={openDrawer}>
              View Request
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default RequestTray;
